import React from "react";

const JobBoardLoader = () => {
  return (
    <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5 h-[800px] bg-green-100 mt-5 mx-5">
      <div className="rounded-xl bg-white h-[385px] w-full p-5 animate-pulse">
        <div class="h-4.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
        <span class="sr-only">Loading...</span>

      </div>
      <div className="rounded-xl bg-white h-[385px] w-full p-5 animate-pulse">
        <div class="h-4.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
        <span class="sr-only">Loading...</span>

      </div>
      <div className="rounded-xl bg-white h-[385px] w-full p-5 animate-pulse">
        <div class="h-4.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
            <span class="sr-only">Loading...</span>

      </div>
      <div className="rounded-xl bg-white h-[385px] w-full p-5 animate-pulse">
        <div class="h-4.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
        <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
            <span class="sr-only">Loading...</span>

      </div>
      
    </div>
  );
};

export default JobBoardLoader;
